import React from 'react';
import { CellRendererProps } from '../../DataTable.types';
import Tooltip from '../../../Tooltip/Tooltip';
import { isEmpty } from '../../../../../utils/utils';

import styles from './TextCellRenderer.module.scss';

export const TextCellRenderer: React.FC<CellRendererProps> = ({ value, row }) => {
    if (isEmpty(value)) {
        return <span> - </span>;
    }
    if (Array.isArray(value)) {
        if (value.length > 1) {
            return (
                <div className={styles.MultiValueCell}>
                    <div className={styles.TruncatedText}>{value[0]},</div>
                    <Tooltip content={value.join(', ')} direction="bottom" usePortal>
                        <span className={styles.MoreCount}> +{value.length - 1} more</span>
                    </Tooltip>
                </div>
            );
        }
    }
    const text = String(value);
    return (
        <Tooltip content={text} direction="top" usePortal containerFullWidth fitContent>
            <div className={styles.TruncatedText}>{text}</div>
        </Tooltip>
    );
};
